import React from 'react';
import { Link } from 'react-router-dom';

const NetworkCard = ({ name, logo }) => {
  return (
    <Link to={`/network/${name.toLowerCase().replace(/\s+/g, '-')}`} className="block">
      <div className="bg-white border border-gray-200 max-w-[300px] rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 p-6 mx-auto">
        {logo && <img src={logo} alt={name} className="w-24 h-24 mx-auto mb-4" />}
        <h2 className="text-xl font-semibold text-center">{name}</h2>
      </div>
    </Link>
  );
};

export default NetworkCard;
